
  import type { PropType } from 'vue';
  import { defineComponent } from 'vue';

  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import IconComponent from '@/common/ui/IconComponent.vue';

  import type { TSortParams, TTableColumnConfig, TTableData } from './types/tableTypes';
  import { TableSortTypes } from './types/tableTypes';

  type TSortableColumn = TTableColumnConfig<TTableData>;

  export default defineComponent({
    name: 'TableSortableHeader',
    components: { IconComponent, ButtonComponent },
    props: {
      columns: {
        type: Array as PropType<TSortableColumn[]>,
        required: true,
      },
      sort: {
        type: Object as PropType<TSortParams | null>,
        default: null,
      },
      headClass: {
        type: String,
        default: '',
      },
    },
    emits: ['sortChange'],
    methods: {
      onColumnClick(column: TSortableColumn) {
        if (!column.sortable) return;

        const current = this.sort;
        const isSameColumn = current?.sortColumn === column.field;

        let next: TSortParams | null;
        if (!current || !isSameColumn) {
          next = { sortColumn: column.field, sortOrder: TableSortTypes.ASCEND };
        } else if (current.sortOrder === TableSortTypes.ASCEND) {
          next = { sortColumn: column.field, sortOrder: TableSortTypes.DESCEND };
        } else {
          next = null;
        }

        this.$emit('sortChange', next);
      },
      getSortClass(column: TSortableColumn) {
        if (!this.sort || this.sort.sortColumn !== column.field) return '';

        return `table-sortable-header__sort_${this.sort.sortOrder}`;
      },
    },
  });
